<template lang="pug">
  div(@click="$router.push(`/slide/${slide.id}`)").wrap-item-home-slide-card.cursor-pointer
    div.wrap-title-img.f.fh
      v-img(:src="slide.titleImg")
    div.wrap-info.py8
      span.fz16.bold.line-clamp-1 {{slide.title}}
      span.fz14.line-clamp-2.mb4 {{slide.description}}
      div.f.fm
        div(v-if="user").wrap-user.f.fm.mr8
          v-avatar(size="20px").mr6
            v-img(:src="user.iconPhotoURL")
          span.fz12 Created by {{user.name}}
        div.f.fm
          v-icon(size="22px").mr6 mdi-clock-outline
          span.fz12 Created at {{createdAtLabel}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-home-slide-card {
  border-bottom: $basic_border;
  .wrap-title-img {
    width: 100%;
    max-height: 420px;
    overflow: hidden;
  }
}
</style>

<script>
import format from 'date-fns/format'
import database from '@/database'

export default {
  props: {
    slide: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    createdAtLabel () {
      return format(this.slide.createdAt.toDate(), 'Pp')
    }
  },
  async created () {
    this.user = await database.userCollection()
      .findById(this.slide.createdBy)
  }
}
</script>
